// extracted by mini-css-extract-plugin
export default {"wrapper":"SuccessSubmission_wrapper__UOSmv"};